"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorIcon = require("./ErrorIcon");
Object.keys(_ErrorIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorIcon[key];
    }
  });
});
